import dayjs from 'dayjs';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetMetricsSummaryQuery } from '../api/metricsApiSlice';
import {
  selectSelectedProjectId,
  selectSummaryBatchTypeId,
  selectSummaryEndDate,
  selectSummaryStartDate,
} from '../state/selector';

export const useMetricSummayDatagridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetMetricsSummaryQuery> => {
  const selectedProjectId = useAppSelector(selectSelectedProjectId);
  const batchTypeId = useAppSelector(selectSummaryBatchTypeId);
  const startDate = useAppSelector(selectSummaryStartDate);
  const endDate = useAppSelector(selectSummaryEndDate);

  return useGetMetricsSummaryQuery(
    {
      batchTypeId: batchTypeId || '',
      projectId: selectedProjectId || '',
      startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : undefined,
      endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
    },
    { skip: !(selectedProjectId && batchTypeId) }
  );
};
